import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
const CircleFilledIcon: FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <circle cx="12" cy="12" r="12" fill="currentColor" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default CircleFilledIcon;